
import PrivateRoute from './PrivateRoute';
import Dashboard from '../client_dashboard/Dashboard';
import ServicesView from '../client_dashboard/services/ServicesView';
import CreateService from '../client_dashboard/services/CreateService';
import CreateCategory from '../client_dashboard/categories/CreateCategories';
import BusinessView from '../client_dashboard/business/BusinessView';
import BusinessHours from '../client_dashboard/business/BusinessHours';
import ServiceIntervals from '../client_dashboard/business/ServiceIntervals';
import EditCategory from '../client_dashboard/categories/EditCategories';
import BusinessInformation from '../client_dashboard/business/BusinessInformation';
import AppointmentViews from "../client_dashboard/appointments/AppointmentViews";
function AuthenticatedRoutes() {
    return (
        <>
            <PrivateRoute path='/dashboard' element={<Dashboard />} />
            <PrivateRoute path='/catalogue/services' element={<ServicesView />} />
            <PrivateRoute path='/catalogue/create-service' element={<CreateService />} />
            <PrivateRoute path='/catalogue/create-category' element={<CreateCategory />} />
            <PrivateRoute path='/business-settings' element={<BusinessView />} />
            <PrivateRoute path='/business-settings/business-hours' element={<BusinessHours />} />
            <PrivateRoute path='/business-settings/service-intervals' element={<ServiceIntervals />} />
            <PrivateRoute path='/business-settings/business-info' element={<BusinessInformation />} />
            <PrivateRoute path='/appointments' element={<AppointmentViews />} />
            <PrivateRoute path='/category/:id' element={<EditCategory />} />
        </>
    );
}

export default AuthenticatedRoutes;